export const COUNTERS = 'COUNTERS';
export const CHANNEL_REPORT = 'CHANNEL_REPORT';
export const GENERAL_ERRORS = 'GENERAL_ERRORS';
export const CHANNEL_REPORT_OPTIONS = 'CHANNEL_REPORT_OPTIONS';
export const CHANNEL_REPORT_PERIOD = 'CHANNEL_REPORT_PERIOD';
